import { FormInput } from '@basqet-dashboard/common/components';
import { KYC_INPUT_TYPE } from '@basqet-dashboard/common/config';
import { capitalize } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React from 'react';

const FilesToBeUploaded = ({ filesList }) => {
  const getInputTypeIcon = (inputType) => {
    if (inputType === KYC_INPUT_TYPE.TEXT) return '📝';
    if (inputType === KYC_INPUT_TYPE.URL) return '🔗';
    return '📄';
  };

  const formattedFilesList = filesList.map((file) => {
    const { checked, value, input_type, inputType } = file;
    const documentInputType = input_type || inputType || KYC_INPUT_TYPE.FILE;
    const label = capitalize(value?.replace(/_/g, ' '));
    const icon = getInputTypeIcon(documentInputType);

    return (
      <li key={file.value || file.name}>
        <FormInput
          type="checkbox"
          label={
            <span>
              {icon} {label}
            </span>
          }
          checked={checked ? 'checked' : ''}
        />
      </li>
    );
  });
  return (
    <div>
      <div className="card files_to_be_uploaded">
        <h3 className="card__title">Documents to be submitted</h3>
        <ul className="files_to_be_uploaded__list card__body">{formattedFilesList}</ul>
      </div>
    </div>
  );
};

FilesToBeUploaded.defaultProps = {
  filesList: [],
  uploadedFiles: []
};
FilesToBeUploaded.propTypes = {
  filesList: PropTypes.array,
  uploadedFiles: PropTypes.array
};
export { FilesToBeUploaded };
